import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getVerottajailmoitettavaProjectsOfUser } from '../services/getVerottajailmoitettavaProjectsOfUser.service';
import { getProjectsActivityFilterCacheKey } from '../utils/getProjectsActivityFilterCacheKey';

export const loadVerottajailmoitettavaProjectsOfUser = createAsyncThunk(
  'projects/loadVerottajailmoitettavaProjectsOfUser',
  async (arg = {}, { getState }) => {
    const activeEmployerInfo =
      arg.activeEmployerInfo || selectUserActiveEmployerInfo(getState());
    const cacheKey = getProjectsActivityFilterCacheKey(activeEmployerInfo);

    const projectIds = await getVerottajailmoitettavaProjectsOfUser({
      activeEmployerInfo,
    });

    return {
      cacheKey,
      projectIds,
    };
  },
  {
    condition: (arg = {}, { getState }) => {
      const state = getState();
      const activeEmployerInfo =
        arg.activeEmployerInfo || selectUserActiveEmployerInfo(state);
      const cacheKey = getProjectsActivityFilterCacheKey(activeEmployerInfo);

      if (!cacheKey) {
        return false;
      }

      const requestStatus =
        state.projects.verottajailmoitettavaProjectIdsRequestStatusByEmployer?.[
          cacheKey
        ];

      if (requestStatus === 'pending') {
        return false;
      }

      if (arg.force || arg.shouldRefetch) {
        return true;
      }

      return requestStatus !== 'fulfilled';
    },
  }
);
